import {
  fetchClient
} from "./chunk-SKVXOXWB.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/experiences/byCategory.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getExperiencesByCategory = (_0) => __async(void 0, [_0], function* ({ lang }) {
  var _a;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/home-venues?step=3&latest_venues=true&deal_venues=true&featured_venues=true&lang=${locale}&visible_in=hy`,
      options: {
        headers: {
          Authorization: ""
        }
      }
    });
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.flatMap((cat) => cat.type === "categories" ? cat.data : cat)) || [];
  } catch (error) {
    throw new Exception({
      error,
      name: "getExperiencesByCategoryException"
    });
  }
});

export {
  getExperiencesByCategory
};
//# sourceMappingURL=chunk-UNBAXGWG.mjs.map